import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
    },
    contentPrices: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10
    },
    infoPrice: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    contentDocument: {
        marginBottom: 20
    }
});

export default styles;
